export const SUPPLIER_INFO_QUERY = '/supplier/:id/info';
export const CLIENT_INFO_QUERY = '/client/:id/info';
export const SUB_ENTITY_INFO_QUERY = '/federated-sub-entities/:id/info';
export const SUPPLIER_CRITICAL_SUPPLIERS_QUERY = '/supplier/:id/suppliers';
